"use client";

import { cn } from "@workspace/ui/lib/utils";
import { ChevronDown, ChevronRight } from "lucide-react";
import { useState } from "react";

interface FieldSectionProps {
  title: string;
  icon?: React.ReactNode;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

export function FieldSection({
  title,
  icon,
  defaultOpen = true,
  children,
}: FieldSectionProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="border-b last:border-b-0">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 w-full px-3 py-2.5 text-base font-semibold text-foreground hover:bg-muted/50 transition-colors"
      >
        {open ? (
          <ChevronDown className="h-4 w-4 shrink-0" />
        ) : (
          <ChevronRight className="h-4 w-4 shrink-0" />
        )}
        {icon && <span className="shrink-0">{icon}</span>}
        <span>{title}</span>
      </button>
      <div className={cn("px-3 pb-3 space-y-2.5", !open && "hidden")}>
        {children}
      </div>
    </div>
  );
}

interface FieldRowProps {
  label: string;
  children: React.ReactNode;
}

export function FieldRow({ label, children }: FieldRowProps) {
  return (
    <div className="flex items-start gap-3 min-h-[28px]">
      <span className="text-sm text-muted-foreground w-24 shrink-0 pt-1 leading-tight">
        {label}
      </span>
      <div className="flex-1 min-w-0">{children}</div>
    </div>
  );
}
